package cz.vojtechhoranek.site.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.UpdateHistoryMode

@Page("/about")
@Composable
fun AboutRedirectPage() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        ctx.router.navigateTo("/", updateHistoryMode = UpdateHistoryMode.REPLACE)
    }
}
